import { useEffect } from "react";
import { downloadFileBlob } from "../../../utils/image";
import { PrintResult } from "../../../interfaces/print";

export const usePrintResultDownloadEffect = (printResults: PrintResult[]) => {
  useEffect(() => {
    if (printResults) {
      printResults.forEach(file => downloadFileBlob(file.image as Blob, file.name, file.format));
    }
  }, [printResults]);
};
